import ProductLayout from "@components/Layouts/ProductLayout"
import Product from "@components/Product/Product"
import usePopular from "@hooks/usePopular"
import { shuffle } from "@utils/common"
import { ProductPageStaticProps } from "@utils/products"
import { GetServerSidePropsContext, InferGetServerSidePropsType } from "next"

const Page = ({
  domain,
  data,
  description,
  noindex,
}: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  const { popularProducts, popularProductsLoading } = usePopular()

  return (
    <ProductLayout>
      <Product
        domain={domain}
        data={data}
        description={description}
        popularProducts={{
          hits:
            popularProducts?.hits && shuffle(popularProducts.hits).slice(0, 12),
          more: popularProducts?.more,
        }}
        popularProductsLoading={popularProductsLoading}
        noindex={noindex}
      />
    </ProductLayout>
  )
}

export default Page

export const getServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const { res } = context
  res.setHeader(
    "Cache-Control",
    "public, s-maxage=3600, stale-while-revalidate"
  )
  return ProductPageStaticProps(context)
}
